/**
 * A fixed red bar on every page when this build is the staging environment
 * (spec §3.2), so a staging tab can never be mistaken for production on race
 * day. VITE_APP_ENV is inlined at build time.
 *
 * Inline styles (not Tailwind classes) on purpose: this app doesn't use
 * Tailwind consistently across every route, and the banner must render
 * identically everywhere regardless of which stylesheets a given page loads.
 */
export function StagingBanner() {
  if (import.meta.env.VITE_APP_ENV !== 'staging') return null;
  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: '#dc2626',
        color: '#fff',
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 700,
        padding: '4px 0',
      }}
    >
      Staging — not production · data is a copy · nothing is sent
    </div>
  );
}
